import {
    GET_ITEMCODE_TO_UPC_REQUEST,
    GET_ITEMCODE_TO_UPC_SUCCESS,
    GET_ITEMCODE_TO_UPC_ERROR,
} from "./types.js";

import { BASEURL } from "../../constant/config.js";
const axios = require("axios");

export const getItemCodeToupc = (token, data) => (dispatch) => {
    dispatch({ type: GET_ITEMCODE_TO_UPC_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/UpcDetailsBySkus`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: {
            "item_code": data
        },
    })
        .then((response) => {

            return dispatch({
                type: GET_ITEMCODE_TO_UPC_SUCCESS,
                payload: response.data,
            });
        })
        .catch((error) => {
            return dispatch({
                type: GET_ITEMCODE_TO_UPC_ERROR,
                payload: error.response,
            });
        });
};


